export default "__VITE_ASSET__CXNcFzNO__"